import { BaseTimeSlotModel as r } from "./baseTimeSlot.model.js";
class i extends r {
  constructor(t) {
    super(t), this.closed = t.closed, this.day = t.day, this.month = t.month, this.year = t.year;
  }
  inDayRange(t) {
    const e = t.get("day") === this.day, n = t.get("month") === this.month, o = !this.year || t.get("year") === this.year;
    return e && n && o;
  }
  inFullRange(t, ...e) {
    return super.inFullRange(t, ...e) && !this.closed;
  }
}
export {
  i as SpecialDayTimeSlotModel
};
//# sourceMappingURL=specialDayTimeSlot.model.js.map
